<script>
import appConfig from "@/app.config";

export default {
  layout: "auth",
  page: {
    title: "Erro 404",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Error 404",
    };
  }
};
</script>

<template>
  <div class="my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <div>
              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="error-img">
                    <img
                      src="@/assets/images/404-error.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4 class="text-uppercase mt-4">Desculpe, não encontramos o que você procura</h4>
            <p class="text-muted">
              Esse dado solicitado não foi encontrado em nosso sistema, talvez você tenha digitado algo incorretamente na URL ou o dado foi apagado do sistema.
            </p>
            <div class="mt-5">
              <router-link to="/" class="btn btn-primary"
                >Voltar a tela inicial</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
